import { AuthSession } from '../../../../types';

/**
 * A logged-out session: no first- or second-factor token. This is the only
 * value ever written to represent "not signed in".
 */
export const unauthenticatedSession = (): AuthSession => ({
  status: 'unauthenticated',
});
